import { createContext, PropsWithChildren, useContext } from 'react';

const ActivePresentationSlideIdContext = createContext<string | undefined>(
  undefined
);

interface PresentationSlideStageProviderProps extends PropsWithChildren {
  activeSlideId?: string;
}

export function PresentationSlideStageProvider({
  activeSlideId,
  children,
}: PresentationSlideStageProviderProps) {
  return (
    <ActivePresentationSlideIdContext.Provider value={activeSlideId}>
      {children}
    </ActivePresentationSlideIdContext.Provider>
  );
}

interface PresentationSlideStageProps {
  inert?: boolean;
  'data-active-presentation-slide'?: true;
}

export function usePresentationSlideStageProps(
  slideId: string
): PresentationSlideStageProps {
  const activeSlideId = useContext(ActivePresentationSlideIdContext);
  if (activeSlideId === undefined) return {};

  const isActive = activeSlideId === slideId;
  return {
    inert: !isActive,
    'data-active-presentation-slide': isActive ? true : undefined,
  };
}
